import styles from "./SelectionForm.module.css"
import { useState, useEffect } from "react"

export default function SelectionForm() {
  let [popupOpen, setPopupOpen] = useState(false)
  useEffect(() => {
    console.log(popupOpen)
  }, [popupOpen])


  const [formData, setFormData] = useState({
    car: "Заявка на подбор",
    phone: "",
    name: "",
  });

  // срабатывает каждый раз при вводе в поле данных
  //e - объект события, автоматически передающийся при изменении формы.
  //e.target - конкретный DOM элемент формы, который вызвал событие
  // name - атрибут поля ввода (car, name, phone)
  // value - текущее значение
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value, //Обновление поля в объекте formData по ключ:значение
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Останавливаем отправку формы

    try {
      const response = await fetch("/api/sendToTelegram.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setPopupOpen(true); // Показываем попап
        setFormData({
          car: "",
          phone: "",
          name: "",
        })
      } else {
        console.error("Ошибка при отправке данных");
      }
    } catch (error) {
      console.error("Ошибка:", error);
    }
  };

  const closePopup = () => {
    setPopupOpen(false);
  }

  return(
    <div className={styles.selectionForm}>
      <h1 className={styles.selectionForm__title}>
        Подберём автомобиль <span className={styles.selectionForm__textHighliter}>качественно</span>
      </h1>
      <p className={styles.selectionForm__description}>
        Расскажите, о каком автомобиле мечтаете, и мы бесплатно поможем найти подходящий вариант
      </p>
      <form onSubmit={handleSubmit} className={styles.selectionForm__form}>
        <label className={styles.selectionForm__label}>
          <input className={styles.selectionForm__input} type="text" placeholder="Как вас зовут?" name="name" onChange={handleChange}/>
        </label>
        <label className={styles.selectionForm__label}>
          <input className={styles.selectionForm__input} minlength="5" type="phone" placeholder="Номер телефона" name="phone" onChange={handleChange} required/>
        </label>
        <button type="submit" className={styles.selectionForm__button}>
          Перезвоните мне
        </button>
      </form>
      <div className={popupOpen?styles.popupOpen:styles.popupClose}>
        <div className={styles.popup}>
          <p className={styles.popup__title}>Спасибо!</p>
          <p className={styles.popup__text}>Мы уже получили Вашу заявку и ответим Вам в течение 15 минут.</p>
          <p className={styles.popup__text}>Не хотите ждать? Позвоните нам:  <br />8-993-983-89-98</p>
          <button className={styles.popup__button} onClick={closePopup}>Отлично!</button>
        </div>
      </div>
    </div>
  )
}